import { queryOptions } from "@tanstack/react-query";
import type {
  OrgMembersData,
  OrgMembersResponse,
} from "@/app/org-members/types";
import { getCoordinatorApi } from "@/lib/api";
import { orgMembersKeys } from "./query-keys";

const fetchOrgMembers = async (
  organizationId: string
): Promise<OrgMembersData> => {
  const client = getCoordinatorApi({ organizationId });
  // TODO: revisit once the data tables support server-side pagination.
  // 500 is the endpoint's hard max; the table paginates client-side, so orgs with
  // more than 500 members would silently render only the first page.
  const { data } = await client.get<OrgMembersResponse>("/members", {
    params: { limit: 500 },
  });
  return data.data;
};

export const orgMembersQueryOptions = (organizationId: string) =>
  queryOptions<OrgMembersData>({
    queryKey: orgMembersKeys.list(organizationId),
    queryFn: () => fetchOrgMembers(organizationId),
    // Each row's `projects` is derived from project membership, which is mutated
    // on other routes (project members, invitations, project create/delete) that
    // don't invalidate this key. The org overview is this query's only consumer,
    // so refetching on mount keeps the projects column fresh on every visit
    // without coupling every membership mutation to this key.
    refetchOnMount: "always",
  });
